import { z } from 'zod';
import { CreateAddressInputDTOSchema } from "../../../addresses/index.js";
import { BasePersonDTOSchema, } from "./persons.dto.js";
// Schema for input validation when creating a person
const CreatePersonServiceInputDTOSchema = BasePersonDTOSchema.omit({
    id: true,
    celcoinId: true,
    createdAt: true,
    updatedAt: true,
    deletedAt: true,
    isDeleted: true,
});
// Action layer DTOs (with address and company context)
const CreatePersonActionInputDTOSchema = CreatePersonServiceInputDTOSchema.extend({
    address: CreateAddressInputDTOSchema.nullable(),
    companyId: z.uuid(),
});
export const CreatePersonInputDTOSchema = CreatePersonActionInputDTOSchema.omit({
    companyId: true,
});
// Request and response schemas for the API layer
export const CreatePersonRequestDTOSchema = z.object({
    body: CreatePersonInputDTOSchema,
    params: z.object({
        companyId: z.uuid(),
    }),
});
//# sourceMappingURL=create-person.dto.js.map